<template>
  <div class="header">
    <div class="header-img" v-if="onlyShowTop">
      <div class="header-img-top">
        <div>
<!--          /tools   /customize  /article -->
          <font-bigger><router-link to="/" class="link">TOOL</router-link></font-bigger>
          <font-bigger><router-link to="/" class="link">COMPONENT</router-link></font-bigger>
          <font-bigger><router-link to="/" class="link">ARTICEL</router-link></font-bigger>
<!--          <font-bigger><router-link to="/office" class="link">OFFICE</router-link></font-bigger>-->
<!--          <font-bigger><router-link to="/view" class="link">VIEW</router-link></font-bigger>-->
<!--          <font-bigger><router-link to="/source" class="link">SOURCE</router-link></font-bigger>-->
        </div>
        <div>
          <!--          /count   /about   -->
          <font-bigger><router-link to="/" style="margin-left:20px;" class="link">统计</router-link></font-bigger>
          <font-bigger><router-link to="/" style="margin-left:20px;" class="link">介绍</router-link></font-bigger>
        </div>
      </div>
      <div class="header-img-title">
        <p>Taneract</p>
        <p>Technology touch lift .</p>
      </div>
    </div>
    <div class="header-top" v-if="!onlyShowTop">
      <div style="margin-left: 70px">
        <font-bigger><router-link to="/" class="top-link">首页</router-link></font-bigger>
        <font-bigger>
        <!--  /tools  -->
          <router-link to="/home" v-show="currentPath === 'tools'"><icon-svg icon-class="tansheji" class="svg"></icon-svg></router-link>
          <router-link to="/home" v-show="currentPath !== 'tools'" class="top-link">工具</router-link>
        </font-bigger>
        <font-bigger>
          <!--  /tools  -->
          <!--  /customize  -->
          <router-link to="/home" v-show="currentPath === 'customize'"><icon-svg icon-class="tanzujian2" class="svg"></icon-svg></router-link>
          <router-link to="/home" v-show="currentPath !== 'customize'" class="top-link">组件</router-link>
        </font-bigger>
        <font-bigger>
          <!--  /article  -->
          <router-link to="/home" v-show="currentPath === 'article'"><icon-svg icon-class="tanzujian" class="svg"></icon-svg></router-link>
          <router-link to="/home" v-show="currentPath !== 'article'" class="top-link">文章</router-link>
        </font-bigger>
      </div>
      <div style="margin-right: 70px">
        <font-bigger>
          <!--  /count  -->
          <router-link to="/home" v-show="currentPath === 'count'"><icon-svg icon-class="tanchengchanglicheng" class="svg"></icon-svg></router-link>
          <router-link to="/home" v-show="currentPath !== 'count'" class="top-link">统计</router-link>
        </font-bigger>
        <font-bigger>
          <!--  /about  -->
          <router-link to="/home" v-show="currentPath === 'about'"><icon-svg icon-class="tangoutongguoshezhi-copy-copy" class="svg"></icon-svg></router-link>
          <router-link to="/home" v-show="currentPath !== 'about'" class="top-link">介绍</router-link>
        </font-bigger>
      </div>
    </div>
    <!-- header占位符 -->
    <div :class="{ headerTopDiv:!onlyShowTop }"></div>
  </div>
</template>

<script>
import FontBigger from '@/components/FontBigger'
export default {
  name: 'HomeHeader',
  components: { FontBigger },
  props:{
    onlyShowTop:{ type:Boolean , default: false　}
  },
  computed:{
    currentPath:function () {
      return this.$route.path.split('/')[1];
    }
  }
}
</script>


<style scoped lang="stylus">
.headerTopDiv
  width 100%
  height 53px
.header
  min-width 1200px
  background-color transparent
  line-height 50px
  width 100%
  .header-img
      background url('../../../public/travel.jpg') no-repeat
      background-size 100%
      padding-bottom 26.6%
      height 0
      .header-img-top
        display flex
        justify-content space-between
        letter-spacing 1px
        text-transform uppercase
        padding-left 70px
        padding-right 70px
        color inherit
      .header-img-title
        margin-top 50px
        color white
        cursor:none
        p:first-child
          font-family Georgia
          margin-bottom 10px
          font-size 60px
          font-weight bolder
          letter-spacing 10px
        p:nth-child(2)
          font-size 16px
          letter-spacing 1px
  .header-top
    padding right 70px
    min-width 1200px
    background-color: white;
    box-shadow: 0 2px 8px #f0f1f2;
    width 100%
    position fixed
    z-index 1001
    top 0
    display flex
    justify-content space-between
    letter-spacing 1px
    text-transform uppercase
  .link
    color white
  .top-link
    color #818181
</style>
